import { QueueItem } from '../../../coaching-tags/models/queue.coaching.model';
import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { Draft, Response } from '../../core';
import { ActionType } from '../form.action';

export interface Reload {
    draftId?: string;

    responseId?: number;

    /** required when draftId is unknown */
    targetUserId?: number;

    templateVersionId: number;

    /** required when draftId is unknown */
    userId?: number;

    /** required to get manager name from manager table for current user */
    timeZoneOffset?: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.EVAL_FORM__RELOAD,
);

export interface ReloadResult extends Reload {
    targetUser?: User;
    draft?: Draft;
    response?: Response;
    queues?: QueueItem[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.EVAL_FORM__RELOAD_RESULT,
);
